const ToolbarContainerTagMap = [
  ["div", "div"],
  ["header", "header"],
  ["section", "section"]
];
export const UitkToolbarContainerTags = new Map(ToolbarContainerTagMap);
